// @flow

import { type UserInputValidationError, type UserInputValidatorArgs, onlyWhenSupport, VALID } from '@tectonics/prs/validation';
import { validateBank } from './bank';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
}: UserInputValidatorArgs): ?UserInputValidationError {
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);


  switch (userInputName) {
    case 'selectedTefBank':
      return onlyWhen('field_tef_select_bank') && validateBank(userInputValue);

    default:
      return VALID;
  }
}
